import { useEffect } from 'react'
import { invokeKhsSXP } from 'src/services/individualService'
import keycloak from 'src/utils/commonMethods/keycloak'
import chatBot from 'src/assets/images/chatBot.svg'
import chatbotPic from 'src/assets/images/cb1.svg'

const KhsDetails = () => {
  const projId = process?.env?.REACT_APP_GET_SXP_KHS_PROJECT_ID

  const invokeSXP = async (sxpBody) => {
    await invokeKhsSXP(sxpBody)
  }

  useEffect(() => {
    const sxpBody = {}
    let mainObj = {
      socketUrl: process?.env?.REACT_APP_SOCKET_URL, // sxp URL
      socketPath: process?.env?.REACT_APP_SOCKET_PATH,
      SSL: true, // secure connection, true for https, false for http
      accessToken: `Bearer ${keycloak?.token}`,
      currentProject: projId, // name of the project / client you are working on / for
      fileServerUrl: process?.env?.REACT_APP_CHAT_FILE_SERVER_URL,
      mainTitle: 'Ask HITA',
      titleLogo: chatbotPic,
      customLauncher: chatBot,
      subTitle:
        '<span>Hi!</span> I am Hita, your personal assistant to help you with insurance-related queries. You can select from the options below.',
      chatRefresh: true,
      autoLaunch: false,
      lazyAutoLaunch: false,
      editChat: false,
      uploadDoc: true,
      defaultMessage: 'Welcome to KHS',
      languages: [],
      version: localStorage.getItem('version'),
      journeyTray: false,
      fieldInputPlaceholder: 'Enter your Message here...',
      closeIcon: {
        showClose: true,
        imgUrl:
          'https://paisaplan.s3.ap-south-1.amazonaws.com/dev/public/emailTemplateIcons/closebutton.png',
      },
    }
    window.embedSXPChat(mainObj)

    invokeSXP(sxpBody).then(() => {
      setTimeout(() => {
        document.getElementsByClassName('sxp_js_chat_closeBtn')[0].click()
      }, 1000)
    })
  }, [projId])
  return <></>
}

export default KhsDetails
